// i18n keys of the multi-tenant work package "bankscan" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  bms_title: 'Bank statement mailbox',
  bms_hint: 'The mailbox the AI Bank scanner reads bank statements from, the passwords that open the statement PDFs, and the accounts it never imports. A setting left empty falls back to the server environment (server/.env).',
  bms_mailbox: 'Mailbox',
  bms_mailbox_env: '— Not set (server environment) —',
  bms_mailbox_env_named: '— Not set (server environment: {{email}}) —',
  bms_mailbox_hint: 'Choose one of the mailboxes connected in the Email module; the scanner signs in with that mailbox’s own settings.',
  bms_not_connected: 'not connected',
  bms_reads_setting: 'The scanner reads {{email}}.',
  bms_reads_env: 'The scanner reads {{email}} (server environment).',
  bms_reads_none: 'No mailbox is configured — the scanner is off.',
  bms_pw: 'Statement PDF passwords',
  bms_pw_setting: '{{n}} set here, stored encrypted (never shown again).',
  bms_pw_env: 'None set here — the scanner uses {{n}} from the server environment.',
  bms_pw_none: 'None set — password-protected statements cannot be opened.',
  bms_pw_unreadable: 'The stored passwords cannot be decrypted (the server key changed) — enter them again.',
  bms_pw_replace: 'Replace passwords',
  bms_pw_clear: 'Remove',
  bms_pw_clear_confirm: 'Remove the stored statement passwords? The scanner falls back to the server environment.',
  bms_pw_placeholder: 'One password per line',
  bms_pw_input_hint: 'Saving replaces every stored password. They are tried in this order. Leave the box empty to keep the current ones.',
  bms_ignored: 'Accounts never imported',
  bms_ignored_placeholder: 'xxx-x-xxxxx-x, …',
  bms_ignored_hint: 'Account numbers, separated by commas. Statements for these accounts are archived without importing and nobody is notified. Empty = server environment.',
  bms_ignored_env: 'Empty here — {{n}} account(s) from the server environment apply.',
  bms_cancel: 'Cancel',
  bms_save: 'Save',
  bms_saving: 'Saving…',
  bms_saved: 'Saved',
};
export const zh: Record<string, string> = {
  bms_title: '银行对账单邮箱',
  bms_hint: 'AI Bank 扫描器读取银行对账单的邮箱、打开对账单 PDF 的密码,以及永不导入的账户。留空的设置沿用服务器环境(server/.env)。',
  bms_mailbox: '邮箱',
  bms_mailbox_env: '— 未设置(服务器环境)—',
  bms_mailbox_env_named: '— 未设置(服务器环境:{{email}})—',
  bms_mailbox_hint: '从邮件模块里已连接的邮箱中选一个;扫描器用该邮箱自己的登录设置。',
  bms_not_connected: '未连接',
  bms_reads_setting: '扫描器读取 {{email}}。',
  bms_reads_env: '扫描器读取 {{email}}(服务器环境)。',
  bms_reads_none: '没有配置邮箱——扫描器已停用。',
  bms_pw: '对账单 PDF 密码',
  bms_pw_setting: '已在此设置 {{n}} 个,加密保存(不再显示)。',
  bms_pw_env: '此处未设置——扫描器使用服务器环境里的 {{n}} 个。',
  bms_pw_none: '未设置——加密的对账单无法打开。',
  bms_pw_unreadable: '已保存的密码无法解密(服务器密钥已变更)——请重新输入。',
  bms_pw_replace: '替换密码',
  bms_pw_clear: '移除',
  bms_pw_clear_confirm: '移除已保存的对账单密码?扫描器将改用服务器环境里的密码。',
  bms_pw_placeholder: '每行一个密码',
  bms_pw_input_hint: '保存会替换全部已存密码,按此顺序逐个尝试。留空则保留现有密码。',
  bms_ignored: '永不导入的账户',
  bms_ignored_placeholder: 'xxx-x-xxxxx-x, …',
  bms_ignored_hint: '账号,用逗号分隔。这些账户的对账单直接归档、不导入、不通知任何人。留空 = 服务器环境。',
  bms_ignored_env: '此处为空——沿用服务器环境里的 {{n}} 个账户。',
  bms_cancel: '取消',
  bms_save: '保存',
  bms_saving: '保存中…',
  bms_saved: '已保存',
};
export const th: Record<string, string> = {
  bms_title: 'กล่องอีเมลรับรายการเดินบัญชี',
  bms_hint: 'กล่องอีเมลที่ตัวสแกน AI Bank ใช้อ่านรายการเดินบัญชีธนาคาร รหัสผ่านสำหรับเปิดไฟล์ PDF รายการเดินบัญชี และบัญชีที่จะไม่นำเข้าเลย การตั้งค่าที่เว้นว่างจะใช้ค่าจากสภาพแวดล้อมของเซิร์ฟเวอร์ (server/.env)',
  bms_mailbox: 'กล่องอีเมล',
  bms_mailbox_env: '— ยังไม่ตั้งค่า (สภาพแวดล้อมของเซิร์ฟเวอร์) —',
  bms_mailbox_env_named: '— ยังไม่ตั้งค่า (สภาพแวดล้อมของเซิร์ฟเวอร์: {{email}}) —',
  bms_mailbox_hint: 'เลือกหนึ่งในกล่องอีเมลที่เชื่อมต่อไว้ในโมดูลอีเมล ตัวสแกนจะเข้าสู่ระบบด้วยการตั้งค่าของกล่องอีเมลนั้น',
  bms_not_connected: 'ไม่ได้เชื่อมต่อ',
  bms_reads_setting: 'ตัวสแกนอ่าน {{email}}',
  bms_reads_env: 'ตัวสแกนอ่าน {{email}} (สภาพแวดล้อมของเซิร์ฟเวอร์)',
  bms_reads_none: 'ยังไม่ได้ตั้งค่ากล่องอีเมล — ตัวสแกนปิดอยู่',
  bms_pw: 'รหัสผ่าน PDF รายการเดินบัญชี',
  bms_pw_setting: 'ตั้งไว้ที่นี่ {{n}} รายการ เก็บแบบเข้ารหัส (จะไม่แสดงอีก)',
  bms_pw_env: 'ยังไม่ได้ตั้งที่นี่ — ตัวสแกนใช้ {{n}} รายการจากสภาพแวดล้อมของเซิร์ฟเวอร์',
  bms_pw_none: 'ยังไม่ได้ตั้ง — เปิดรายการเดินบัญชีที่มีรหัสผ่านไม่ได้',
  bms_pw_unreadable: 'ถอดรหัสรหัสผ่านที่เก็บไว้ไม่ได้ (คีย์ของเซิร์ฟเวอร์เปลี่ยน) — กรุณาป้อนใหม่',
  bms_pw_replace: 'แทนที่รหัสผ่าน',
  bms_pw_clear: 'ลบ',
  bms_pw_clear_confirm: 'ลบรหัสผ่านรายการเดินบัญชีที่เก็บไว้หรือไม่? ตัวสแกนจะกลับไปใช้ค่าจากสภาพแวดล้อมของเซิร์ฟเวอร์',
  bms_pw_placeholder: 'บรรทัดละหนึ่งรหัสผ่าน',
  bms_pw_input_hint: 'การบันทึกจะแทนที่รหัสผ่านที่เก็บไว้ทั้งหมด และจะลองตามลำดับนี้ เว้นว่างไว้เพื่อคงรหัสผ่านเดิม',
  bms_ignored: 'บัญชีที่ไม่นำเข้า',
  bms_ignored_placeholder: 'xxx-x-xxxxx-x, …',
  bms_ignored_hint: 'เลขที่บัญชี คั่นด้วยเครื่องหมายจุลภาค รายการเดินบัญชีของบัญชีเหล่านี้จะถูกจัดเก็บโดยไม่นำเข้าและไม่แจ้งใคร เว้นว่าง = สภาพแวดล้อมของเซิร์ฟเวอร์',
  bms_ignored_env: 'ว่างอยู่ — ใช้ {{n}} บัญชีจากสภาพแวดล้อมของเซิร์ฟเวอร์',
  bms_cancel: 'ยกเลิก',
  bms_save: 'บันทึก',
  bms_saving: 'กำลังบันทึก…',
  bms_saved: 'บันทึกแล้ว',
};
